import { createContext, useContext } from 'react';

/**
 * The open consumer report count, the sidebar badge's number. The shell reads
 * it once per session and the inbox corrects it after its own load and after
 * each status change, so the badge and the page header never disagree. D13.
 */
export interface OpenReports {
  count: number | null;
  set(count: number): void;
}

export const OpenReportsContext = createContext<OpenReports>({ count: null, set: () => {} });

export const useOpenReports = () => useContext(OpenReportsContext);
